import {
  createColumnHelper,
  type AccessorFnColumnDef,
  type RowData,
} from '@tanstack/react-table';

import { RowSelectionCell, RowSelectionHeader } from './RowSelectionCells.js';
import { BuiltinColumnHeaderName } from '../../components/BuiltinColumnHeaderName.js';
import {
  DATA_TABLE_BUILTIN_COLUMN_MIN_WIDTH,
  DATA_TABLE_ROW_SELECTION_COLUMN_ID,
} from '../../constants.js';
import { dataTableMessages } from '../../messages.js';
import type { TDataTableFeatures } from '../types/features.types.js';

const rowSelectionColumnHelper = createColumnHelper<
  TDataTableFeatures,
  RowData
>();

export const ROW_SELECTION_COLUMN: AccessorFnColumnDef<
  TDataTableFeatures,
  RowData,
  string
> = rowSelectionColumnHelper.accessor(() => '', {
  id: DATA_TABLE_ROW_SELECTION_COLUMN_ID,
  alignment: 'left',
  header: ({ table }) => (
    <>
      <BuiltinColumnHeaderName
        message={dataTableMessages.rowSelectionColumnName}
      />
      <RowSelectionHeader table={table} />
    </>
  ),
  width: 'content',
  minWidth: DATA_TABLE_BUILTIN_COLUMN_MIN_WIDTH,
  enableSorting: false,
  enableResizing: false,
  enableUserActions: false,
  enableHiding: false,
  meta: {
    builtin: true,
    hasCustomCellRenderer: true,
    hasCustomHeaderRenderer: true,
    builtinPlacement: 'prefix',
    cellDeps: (cell) => {
      return [
        cell.row.getIsSelected(),
        cell.row.getIsAllSubRowsSelected(),
        cell.row.getIsSomeSelected(),
        cell.row.getCanSelect(),
        cell.row.getShouldDisableRowSelection(),
      ];
    },
  },
  cell: ({ row }) => <RowSelectionCell row={row} />,
});
